import { render } from "./Carousel.vue?vue&type=template&id=ad01f7b2"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"
script.render = render

export default script